// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet crm-internal API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainMarktsegment =
  (typeof SUREbusinessCommonDomainMarktsegment)[keyof typeof SUREbusinessCommonDomainMarktsegment];

export const SUREbusinessCommonDomainMarktsegment = {
  Particulier: 'Particulier',
  Zakelijk: 'Zakelijk',
} as const;
